<template>
    <!-- <vProjectPreview :views="views" v-model="chosenView"> -->
    <PreviewIframePage
        :back="page.transparentBackground ? '' : page.pageColor"
        :src="`/preview/pages/${page.uuid}`"
        @action="action($event)"
    />
    <!-- </vProjectPreview> -->
</template>

<script>
//import vProjectPreview from "@/shared/views/vProjectPreview.vue";
import { PAGE_PREVIEW_KIND, PAGE_ROUTE_NAMES } from "@/apps/page/page.routes";
import { mapActions, mapMutations, mapState } from "vuex";
import { PageIcon } from "@easy/ui/icons";
import { ref } from "vue";
import { useMagicFieldExchangeStore } from "@/apps/page/services/magic-field-exchange.store";
import PreviewIframePage from "@/shared/views/PreviewIframePage.vue";

export default {
    name: "PageProjectPreview",
    components: {
        PreviewIframePage,
        // vProjectPreview,
    },
    emits: ["createToolProject"],
    mounted() {
        this.$watch(
            () => [this.page, this.sections, this.size, this.chosenView, this.lang],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );
    },
    setup() {
        const chosenView = ref(PAGE_PREVIEW_KIND.page);
        const { exchangeContent } = useMagicFieldExchangeStore();
        return { chosenView, exchangeContent };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("page", ["page", "sections"]),
        views() {
            return [
                {
                    label: "PAGE",
                    value: PAGE_PREVIEW_KIND.page,
                    icon: PageIcon,
                },
            ];
        },
        fontFamilyStyle() {
            return { "font-family": this.page.fontFamily };
        },
    },
    methods: {
        ...mapMutations("page", ["setIframeLoaded"]),
        ...mapActions("page", [
            "refreshIframe",
            "fillWithExample",
            "moveSection",
            "hideBlockElement",
            "toggleHideSection",
            "removeSection",
            "setOrderSections",
            "createBlockSection",
            "createToolSection",
            "connectToolSectionWithProject",
            "bindToolSectionWithProject",
        ]),
        createSection() {
            this.routeTo(PAGE_ROUTE_NAMES.projectSections, "addSection");
        },
        routeTo(name, open, rest) {
            const { query } = this.$route;
            this.$router.push({ name, query: { ...query, open, ...rest } });
        },
        action(action) {
            switch (action.name) {
                case "hideBlockElement":
                    this.hideBlockElement(action.data);
                    break;
                case "magicallyExchangeContent":
                    this.exchangeContent(action.data);
                    break;
                case "moveSection":
                    this.moveSection(action.data);
                    break;
                case "hideSection":
                    this.toggleHideSection(action.data);
                    break;
                case "removeSection":
                    this.removeSection(action.data).then(() => {
                        // If the section is removed, we need to reset the sidebar mode [EAS-2432]
                        this.routeTo(PAGE_ROUTE_NAMES.projectSections, "list");
                    });
                    break;
                case "setOrderSections":
                    this.setOrderSections(action.data);
                    break;
                case "createBlock":
                    this.createBlockSection(action.data).then(() => {
                        // from now on [EAS-2446] Do not open editor
                        /*
                        // remove comment when approved by @Greg!
                        this.routeTo(PAGE_ROUTE_NAMES.projectSections, "createBlock", {
                            id,
                        });
                        */
                    });
                    break;
                case "createToolSection":
                    this.createToolSection(action.data).then(({ id }) => {
                        this.routeTo(PAGE_ROUTE_NAMES.projectSections, "editSection", {
                            id,
                        });
                    });
                    break;
                case "createToolProject":
                    this.$emit("createToolProject", action.data);
                    break;
                case "publishToolProject":
                    // eslint-disable-next-line no-case-declarations
                    const { tool, uuid } = action.data;
                    this.$router.push(`/${tool}/projects/${uuid}?page=${this.page.uuid}`);
                    break;
                case "connectToolSectionWithProject":
                    this.connectToolSectionWithProject(action.data).then(async (projectUuid) => {
                        const { tool } = action.data;
                        if (projectUuid) {
                            await this.$router.push(
                                `/${tool}/projects/${projectUuid}?page=${this.page.uuid}`
                            );
                        }
                    });
                    break;
                case "bindToolSectionWithProject":
                    this.bindToolSectionWithProject(action.data).then(async (projectUuid) => {
                        const { tool } = action.data;
                        if (projectUuid) {
                            await this.$router.push(
                                `/${tool}/projects/${projectUuid}?page=${this.page.uuid}`
                            );
                        }
                    });
                    break;
            }
        },
    },
};
</script>
